<!-- begin::User -->
<div class="d-flex align-items-center"
     [ngClass]="toolbarButtonMarginClass"
     id="kt_header_user_menu_toggle">
  <a class="lang-switch-btn btn btn-active-light-primary btn-light " *ngIf="language == 'ar'" (click)="switchLang('en')">
    <i class="fas fa-globe mr-2"></i> English
  </a>
  <a class="lang-switch-btn btn btn-active-light-primary btn-light" *ngIf="language == 'en'" (click)="switchLang('ar')">
    العربيه <i class="fas fa-globe ms-2"></i>
  </a>
  <div ngbDropdown class="d-inline-block">
    <div ngbDropdownToggle class="btn btn-active-light btn-light d-flex align-items-center bg-hover-light py-2 px-2 px-md-3 ms-5" data-kt-menu-trigger="click" data-kt-menu-attach="parent" data-kt-menu-placement="bottom-end">
      <div class="d-none d-md-flex flex-column align-items-end justify-content-center me-2">
        <span class="text-muted fs-7 fw-bold lh-1 mb-2">Hello</span>
        <span class="text-dark fs-base fw-bolder lh-1">Michael</span>
      </div>
      <div class=" symbol symbol-35px">
        <h6 class="symbol-label font-size-h5 font-weight-bold bg-light-success ml-2 mb-0">M</h6>
      </div>
    </div>
    <div ngbDropdownMenu class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold fs-6 w-275px">
      <div class="drop-item">
        <div class="d-flex flex-column flex-center bgi-no-repeat rounded-top px-9 py-10" style="background-image: url('./src/assets/images/menu-header-dark.png')">
          <div class="text-white fw-bold mb-3">
            Michael louis
          </div>
        </div>
      </div>
      <div class="menu-item ">
        <a class="menu-link px-5 cursor-pointer py-4 d-flex justify-content-center" (click)="logout($event)" > {{getResourceValue("Sign Out")}}</a>
      </div>
    </div>
  </div>
</div>
<!-- end::User -->
<!-- <ng-container *ngIf="headerLeft === 'menu'">
  <div
    class="d-flex align-items-center d-lg-none ms-2 me-n3"
    title="Show header menu"
  >
    <div
      class="
        btn btn-icon btn-active-light-primary
        w-30px
        h-30px
        w-md-40px
        h-md-40px
      "
      id="kt_header_menu_mobile_toggle"
    >
      <span
        [inlineSVG]="'./assets/media/icons/duotune/text/txt001.svg'"
        class="svg-icon svg-icon-1"
      ></span>
    </div>
  </div>
</ng-container> -->
